module.exports = __webpack_public_path__ + "img/chili-plain.17c19133.svg";